import { render, staticRenderFns } from "./zapier.vue?vue&type=template&id=4525996e&scoped=true&"
import script from "./zapier.vue?vue&type=script&lang=js&"
export * from "./zapier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525996e",
  null
  
)

export default component.exports